import { render } from "@testing-library/react";
import React from "react";
import { useEffect, useState, useMemo, useRef } from "react";
import {
  Container,
  Row,
  Col,
  ListGroup,
  Tab,
  Button,
  Card,
  Badge,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import moment from "moment/moment";
import * as Icon from "react-bootstrap-icons";
import { ThreeCircles } from "react-loader-spinner";
import { logout } from "../../utils";
import AgGrid from "../../reusable-components/AgGridComponent/AgGrid";
import './AutomatedReports.css'
import { ToastContainer, toast } from "react-toastify";
import { makeCygnusApiCall } from "../../api/api";


function DownloadedReports() {
  const [dataSource, setDataSource] = useState(null);

  const [selectedRowData, setSelectedRowData] = useState({});
  const [isDownloading, setIsDownloading] = useState(false);

  const gridRef = useRef();

  const onSelectionChanged = () => {
    const selectedData = gridRef.current.api.getSelectedRows();
    console.log("Selection Changed", selectedData);
  };

  const getRequestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  useEffect(() => {
    const getDownloadedReports = async () => {
      const data = await makeCygnusApiCall({
        type: "GET",
        payload: {},
        url: "/downloaded_reports/",
        show_message: false,
        customized_success_message: "Got your downloaded reports. Let the games begin.",
        customized_failure_message: "Unable to fetch your downloaded reports, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while fetching your downloaded reports, please contact support and attach a screenshot.",
        isblob: false
      })
      if (data["Data"] !== undefined) {
        let modifiedData = data["Data"]
          .filter((el) => el.status !== "Completed: 0 Failed: 1")
          .map((el) => {
            return {
              id: el.download,
              reportnames: el.reportnames.substr(1, el.reportnames.length - 2),
              starttime: `${moment(el.starttime.substr(0, 10)).format(
                "MM-DD-YYYY"
              )}   ${el.starttime
                .substr(12, el.starttime.length - 1)
                .replaceAll("-", ":")}`,
              endtime: `${moment(el.endtime.substr(0, 10)).format(
                "MM-DD-YYYY"
              )}   ${el.endtime
                .substr(12, el.endtime.length - 1)
                .replaceAll("-", ":")}`,
              completed: el.status.split("<br>")[0].split(":")[1],
              failed: el.status.split("<br>")[1].split(":")[1],
              type: el.type,
              download: "Download",
            };
          });
        setDataSource(modifiedData);
      }
    }
    getDownloadedReports()
  }
  )

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: 400, width: "100%" }), []);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );

  const BtnCellRenderer = (props) => {
    console.log("+++++++++++++ =========== +++++++++++++", props, props.data);
    const editClick = async () => {
      setIsDownloading(true);
      const data = await makeCygnusApiCall({
        type: "GET",
        payload: {},
        url: `/zip_download/?FolderId=${props.data.id}`,
        show_message: false,
        customized_success_message: "Got your downloaded reports. Let the games begin.",
        customized_failure_message: "Unable to zip download, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while converting to zip and download, please contact support and attach a screenshot.",
        isblob: false
      })
      if (data && data.download_url) {
        var fileUrl = data.download_url;
        var fileName = "test.zip";
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = fileUrl;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(fileUrl);
        setIsDownloading(false);
        setTimeout(() => {
          toast.success("File download successful!");
        }, 2000);
      }
    }

    // const buttonClick = () => { }
    return (
      <>
        <span>
          <Button className="grid-button" onClick={() => editClick()}>
            <Icon.Download />
          </Button>
          &nbsp;
        </span>
      </>
    );
  };

  const columnDefs = [
    { field: "id", hide: true },
    { field: "reportnames" },
    { field: "starttime" },
    { field: "endtime" },
    { field: "completed" },
    { field: "failed" },
    { field: "type" },
    {
      field: "download",
      cellRenderer: BtnCellRenderer,
      cellRendererParams: {
        selectedRow: setSelectedRowData,
      },
    },
  ];

  const sortable = true;
  const filter = true;
  const resizable = true;

  return (
    <Container fluid>
      <span style={{ display: "none" }}>
        {isDownloading === true && toast.info("Downloading file...")}
      </span>
      <Row>
        <Col xs={12}>
          <Row style={{ background: "rgb(251, 242, 207)", padding: "5px" }}>
            <NavLink
              to="/automatedReports"
              className="black"
              style={{
                padding: "5px",
                fontWeight: "bold",
                cursor: "pointer",
                color: "#000 !important",
                width: "10%",
                display: "inline-block",
                textAlign: "center",
              }}
            >
              <span> On Demand Reports</span>
            </NavLink>

            <NavLink
              to="/automatedReports/scheduledReports"
              className="black"
              style={{
                padding: "5px",
                fontWeight: "bold",
                cursor: "pointer",
                width: "10%",
                display: "inline-block",
                textAlign: "center",
              }}
            >
              {" "}
              Scheduled Reports
            </NavLink>
            <NavLink
              to="/automatedReports/downloadedReports"
              className="secondary-menu-active black"
              style={{
                padding: "5px",
                fontWeight: "bold",
                cursor: "pointer",
                color: "#000",
                width: "10%",
                display: "inline-block",
                textAlign: "center",
              }}
            >
              <span>Downloaded Reports</span>
            </NavLink>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xs={"11"}>
          <h2 className="display-6 mt-4">Downloaded Reports</h2>
        </Col>
        {dataSource ? (
          <div style={containerStyle} className="mt-5">
            <div className="ag-theme-alpine" style={gridStyle}>
              <AgGrid
                ref={gridRef}
                rowData={dataSource}
                columnDefs={columnDefs}
                sortable={sortable}
                filter={filter}
                resizable={resizable}
              />
            </div>
          </div>
        ) : (
          <div style={{ position: "relative", top: "50px", left: "48%" }}>
            <ThreeCircles
              height="100"
              width="100"
              color="#4fa94d"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="three-circles-rotating"
              outerCircleColor="var(--theme1_primary)"
              innerCircleColor="var(--theme1_secondary)"
              middleCircleColor="var(--theme1_tertiary)"
              onSelectionChanged={onSelectionChanged}
            />
            <h5
              style={{
                position: "relative",
                left: "-5%",
                padding: "10px",
              }}
            >
              Fetching Downloaded Reports
            </h5>
          </div>
        )}
      </Row>
    </Container>
  );
}

export default DownloadedReports;
